import { useState } from 'react'
import { DatePicker, Segmented, Space, Tag } from 'antd'
import { changeCurrentBudgetPeriodId } from 'src/pages/budget/budgetRequests/model'
import dayjs, { Dayjs } from 'dayjs'
import 'dayjs/locale/ru'
import ruRU from 'antd/es/date-picker/locale/ru_RU'
import {
  STATUS_PERIOD_COLOR,
  STATUS_PERIOD_LABELS,
} from 'src/pages/budget/const'
import { BudgetPeriodState } from 'src/pages/budget/budgetRequests/types'

type Props = {
  budgetPeriod: BudgetPeriodState
}

export const BudgetPeriod = ({ budgetPeriod }: Props) => {
  dayjs.locale('ru')
  const [mode, setMode] = useState<'month' | 'year' | 'decade'>('month')
  const { byPeriod, byId, currentPeriodId, segmentedPeriodOptions } =
    budgetPeriod

  const allowedMonths = [...byPeriod.keys()]
  const allowedYears = new Set(
    allowedMonths.map((m) => dayjs(m, 'YYYY-MM').year()),
  )

  const handleChangeSegmented = (id?: number) => {
    if (!id) return
    changeCurrentBudgetPeriodId({ id })
  }

  const handleChangeDatePicker = (value: Dayjs | null) => {
    if (!value) return
    const key = value.format('YYYY-MM')
    const id = byPeriod.get(key)
    if (!id) return
    changeCurrentBudgetPeriodId({ id })
  }

  const datePickerValue = currentPeriodId
    ? dayjs(byId.get(currentPeriodId)?.periodFormatted, 'YYYY-MM')
    : null

  return (
    <Space size="large">
      <Segmented
        value={currentPeriodId ?? undefined}
        options={segmentedPeriodOptions}
        onChange={handleChangeSegmented}
        shape="round"
        size="large"
      />

      <DatePicker
        size="large"
        picker="month"
        locale={ruRU}
        placeholder="Архив месяцев"
        allowClear={false}
        format={(value) =>
          value
            ? value.format('MMMM YYYY').replace(/^./, (c) => c.toUpperCase())
            : ''
        }
        style={{ width: 200 }}
        onPanelChange={(_, newMode) => {
          if (
            newMode === 'month' ||
            newMode === 'year' ||
            newMode === 'decade'
          ) {
            setMode(newMode)
          }
        }}
        disabledDate={(current) => {
          if (!current) return false
          if (mode === 'month') {
            return !allowedMonths.includes(current.format('YYYY-MM'))
          }
          const year = current.year()
          if (mode === 'year') {
            return !allowedYears.has(year)
          }
          if (mode === 'decade') {
            const startYear = Math.floor(year / 10) * 10
            const endYear = startYear + 9
            const hasYearInDecade = Array.from(allowedYears).some(
              (y) => y >= startYear && y <= endYear,
            )
            return !hasYearInDecade
          }
          return false
        }}
        value={datePickerValue}
        onOpenChange={(open) => {
          if (!open) setMode('month')
        }}
        onChange={handleChangeDatePicker}
      />
      <>
        {currentPeriodId &&
          (() => {
            const statusKey = byId.get(currentPeriodId)?.status
            const statusLabel = statusKey ? STATUS_PERIOD_LABELS[statusKey] : ''
            const statusColor = statusKey ? STATUS_PERIOD_COLOR[statusKey] : ''
            return (
              <Space style={{ fontSize: 18 }}>
                Статус:{' '}
                <Tag
                  style={{ fontSize: 14, padding: '3px 6px' }}
                  color={statusColor}
                >
                  {statusLabel}
                </Tag>
              </Space>
            )
          })()}
      </>
    </Space>
  )
}
